<template>
    <button class="gotopo" id="gotopo" v-scroll-to="'header'">
        <div class="gotopo-img">
            <img src="@/assets/img/layout/gotopo.png" alt="" />
        </div>
    </button>
</template>
<script>
export default {
    data() {
        return {
            showScroll: false,
        };
    },
    methods: {
        handleScroll(event) {
            if (document.documentElement.scrollTop >= window.innerHeight) {
                document.getElementById("gotopo").style.display = "flex";
            } else {
                document.getElementById("gotopo").style.display = "none";
            }
        },
    },
    created() {
        window.addEventListener("scroll", this.handleScroll);
    },
    mounted() {
        document.getElementById("gotopo").style.display = "none";
    },
};
</script>
<style lang="scss" scoped>
.gotopo {
    border: 0;
    cursor: pointer;
    //box-shadow: -4px 4px 0px 0px rgba(0,0,0,0.25);
    position: fixed;
    right: calc((100% - 1910px) / 2);
    top: 20%;
    z-index: 9999;
    display: flex;
    background-color: transparent;
    padding: 0;
    // border-top-left-radius: 30px;
    // border-bottom-left-radius: 30px;
    &-container {
        z-index: 10000;
        height: 100vh;
        position: absolute;
        width: 100%;
        margin: auto;
        max-width: 1366px;
    }
    &-img {
        // padding-right: 5px;
        // padding-left: 10px;
    }
    @media (max-width: 1366px) {
        right: 0;
    }
}
</style>